import { atom } from 'jotai';

const SALES_TAX = 8.625;

export const customerAtom = atom({
  name: '',
  phoneNumber: '',
  emailAddress: '',
  confirmationNumber: undefined
});

export const menuAtom = atom([]);

/**
 * The menu items the user has selected
 */
export const orderedMenuItemsAtom = atom((get) => {
  const menu = get(menuAtom);
  return menu.filter((menuItem) => menuItem.quantity > 0)
});

/**
 * Total price for the order
 */
export const totalPriceAtom = atom((get) => {
  const orderedItems = get(orderedMenuItemsAtom);
  return orderedItems.reduce((accum, current) => {
    return accum + (current.price * current.quantity);
  }, 0)
});

/**
 * Total price for the order including tax
 */
export const totalPriceWithTaxAtom = atom((get) => {
  const total = get(totalPriceAtom);
  const tax = total * (SALES_TAX / 100);
  return Number(total + tax).toFixed(2);
});

